import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900">Terms and Conditions</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>

        <section className="mt-8 space-y-6 text-[15px] leading-7">
          <p>
            These Terms and Conditions ("Terms") govern your access to and use of Omabra Poultry Assistant ("Service"). By creating an account or using the Service, you agree to these Terms.
          </p>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">1. Service Description</h2>
            <p className="mt-2">Omabra provides farm management tools including records, reminders, analytics, AI assistance, and a marketplace interface.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">2. Eligibility and Account</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>You must be at least 18 years old and capable of entering a binding agreement.</li>
              <li>Provide accurate information and maintain the security of your account credentials.</li>
              <li>You are responsible for all activity under your account.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">3. Subscription and Billing</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Paid plans are billed in advance and are non‑refundable except where required by law.</li>
              <li>Trials are one‑time per account. Upgrades take effect immediately; downgrades apply next cycle.</li>
              <li>Taxes may apply depending on your location and will be added where required.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">4. Acceptable Use</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>Do not misuse the Service, disrupt its operation, or attempt unauthorized access.</li>
              <li>Do not upload unlawful, harmful, or infringing content.</li>
              <li>You must comply with applicable laws and regulations in your jurisdiction.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">5. Data and Content</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>You retain ownership of content you submit. You grant us a limited license to process it to provide the Service.</li>
              <li>We may anonymize and aggregate usage data to improve the Service.</li>
              <li>See our Privacy Policy for how we collect and process personal data.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">6. AI Assistant</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>AI outputs may be inaccurate or incomplete. Use professional judgment before acting on advice.</li>
              <li>Do not input sensitive personal data beyond what is necessary.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">7. Third‑Party Services</h2>
            <p className="mt-2">The Service may link to third‑party services (e.g., email, payment, logistics). We are not responsible for their content or policies.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">8. Termination</h2>
            <ul className="mt-2 list-disc pl-6 space-y-2">
              <li>You may cancel at any time from the Billing page.</li>
              <li>We may suspend or terminate accounts for breach of these Terms or misuse.</li>
              <li>Upon termination, access ends but certain sections (e.g., liability, IP, governing law) survive.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">9. Disclaimers</h2>
            <p className="mt-2">The Service is provided "as is" without warranties of any kind. We do not guarantee accuracy, uptime, or fitness for a particular purpose.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">10. Limitation of Liability</h2>
            <p className="mt-2">To the maximum extent permitted by law, Omabra and its affiliates are not liable for indirect, incidental, special, consequential, or punitive damages, or loss of profits, data, or goodwill.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">11. Indemnity</h2>
            <p className="mt-2">You agree to indemnify and hold Omabra harmless from claims arising out of your use of the Service or violation of these Terms.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">12. Changes to the Terms</h2>
            <p className="mt-2">We may update these Terms. We will post the new version with an updated date. Continued use after changes means you accept the revised Terms.</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900">13. Contact</h2>
            <p className="mt-2">Questions? Contact us at support@omabra.co.ke.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Terms;


